export const getCampaignItemVisibilityFilter = (hiddenVisibilityFilter: boolean) => {
  // Constants representing visibility statuses
  const VISIBLE_ITEMS = [1] // Visible item (included in finances)
  const HIDDEN_ITEMS = [2, 3] // Hidden items (include and exclude from finances)

  // Apply the filter based on the `hiddenVisibilityFilter` value
  return hiddenVisibilityFilter ? HIDDEN_ITEMS : VISIBLE_ITEMS
}
